/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import React from 'react'
import { useLayout } from '../../core'
import { TopbarOnboarding } from './TopbarOnboarding'
import { toAbsoluteUrl } from '../../../helpers'

export function HeaderWrapperOnboarding() {
  const { classes, attributes } = useLayout()

  return (
    <div
      id='kt_header'
      className={clsx('header-onboarding', classes.header.join(' '), 'align-items-stretch')}
      {...attributes.headerMenu}
    >
      <div
        className={clsx(
          classes.headerContainer.join(' '),
          'd-flex align-items-stretch justify-content-between'
        )}
      >

        {/* begin::Navbar */}
        <div className='d-flex align-items-center flex-shrink-0' id='kt_header_logo'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/Logo.svg')} className='h-30px' />
        </div>

        <div className='d-flex align-items-stretch flex-shrink-0'>
          <TopbarOnboarding />
        </div>
        {/* </div> */}
      </div>
    </div>
  )
}
